import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import sitemap from '@/Router/sitemap';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger
} from '@/components/Accordion';
import { localizedRoute } from '@/utils/locale';

function SitemapMobile() {
	const { t } = useTranslation();
	return (
		<Accordion type="single" collapsible className="mt-[52px] w-full">
			{sitemap.map(({ title, links }, index) => {
				return (
					<AccordionItem
						key={`sitemap${index}`}
						value={`sitemap${index}`}
						className="data-[state=open]:border-red"
					>
						<AccordionTrigger
							className="flex h-14 shrink grow basis-0 items-center"
							Component="p"
						>
							<span className="inline-flex text-sm font-semibold text-red">
								{t(title)}
							</span>
						</AccordionTrigger>
						<AccordionContent className="flex flex-col">
							{links.map((item, i) => {
								return (
									<Link
										className="mb-3 justify-start text-left text-sm leading-7 text-grey-500 transition-colors hover:text-red"
										to={localizedRoute(item.to)}
										key={`sitemap-item${i}`}
									>
										{t(item.text)}
									</Link>
								);
							})}
						</AccordionContent>
					</AccordionItem>
				);
			})}
		</Accordion>
	);
}

export default SitemapMobile;
